<!-- page starts-->
    <section class="page-wrapper">
      <div class="ashton-hero-top fixtures">
        <div class="container">
        	<div class="fixtures-top-detail">
               <div class="red-titel">Fixtures</div>
	            <div class="ashton-hero-center-player-tab">
	                <ul>
	                    <li class="courses-name " id="men"><a routerLink="/fixtures">Men’s Team</a></li>
	                    <li class="courses-name active" id="women"><a routerLink="/fixtures-women">Women’s Team</a></li>
	                    <li class="courses-name " id="junior"><a routerLink="/fixtures-junior">Junior’s Team</a></li>
	                </ul>
	            </div>
            </div>
        </div>
        <div class="fixtures-top-detail-banner cf">
        	<div class="fixtures-top-detail-slider">
        		<div class="fixtures-top-detail-slider-box" *ngFor="let matchs of matchsList?.data | slice:0:1">
        			<div class="fixtures-top-detail-slider-box-left">
        				<div class="fixtures-top-detail-slider-box-left-text">
        					<p>{{matchs?.first_name}}</p>
        				</div>
        				<div class="fixtures-top-detail-slider-box-left-image">
        					<img [src]="matchs?.first_image" alt="Bitmap">
        				</div>
        			</div>
        			<div class="fixtures-top-detail-slider-box-center">
        				<div class="fixtures-top-detail-slider-box-center-inner">
	        				<h3>Home 15:00</h3>
	        				<p>{{matchs?.date_time}}</p>
	        			</div>
        			</div>
        			<div class="fixtures-top-detail-slider-box-right">
        				<div class="fixtures-top-detail-slider-box-left-image">
        					<img [src]="matchs?.second_image" alt="Bitmap">
        				</div>
        				<div class="fixtures-top-detail-slider-box-left-text">
        					<p>{{matchs?.second_name}}</p>
        				</div>
        			</div>
        		</div>
        		<div class="fixtures-top-detail-slider-btn">
        			<a href="javascript:void(0);">Buy Tickets</a>
        		</div>
        	</div>
        </div>
        <div class="fixtures-center-detail-section cf">
        	<div class="container">
        		<div class="fixtures-center-detail cf">
        			<div class="fixtures-center-detail-left">
        				<div class="caleandar-box">
                            
                        </div>
        			</div>
        			<div class="fixtures-center-detail-right">
        				<div class="fixtures-center-detail-right-box cf" *ngFor="let matchs of matchsList?.data">
        					<div class="fixtures-center-detail-right-box-top cf">
		        				<div class="fixtures-center-detail-right-left">
		        				    <div class="fixtures-top-detail-slider-box-left-text">
		        					   <p>{{matchs?.first_name}}</p>
		        				    </div>
		        				    <div class="fixtures-top-detail-slider-box-left-image">
		        					  <img [src]="matchs?.first_image" alt="Bitmap">
		        				    </div>	
		        				</div>
		        				<div class="fixtures-center-detail-right-center">
		        				    <div class="fixtures-top-detail-slider-box-center-inner">
			        				   <h2>VS</h2>
			        			    </div>	
		        				</div>
		        				<div class="fixtures-center-detail-right-right">
		        					<div class="fixtures-top-detail-slider-box-left-image">
		        					    <img [src]="matchs?.second_image" alt="Bitmap">
		        				    </div>
		        				    <div class="fixtures-top-detail-slider-box-left-text">
		        					   <p>{{matchs?.second_name}}</p>
		        				    </div>
		        				</div>
		        			</div>
	        			    <div class="fixtures-center-detail-right-box-bottom cf">
	        			    	<div class="fixtures-center-detail-right-box-bottom-left">
	        			    		<p>{{matchs?.date_time}} |  Home 15:00 </p>
	        			    	</div>
	        			    	<div class="fixtures-center-detail-right-box-bottom-btn">
	        			    		<a href="javascript:void(0);">Book Tickets</a>
	        			    	</div>
	        			    </div>
	        			</div>
        			</div>
        		</div>
        		
        	</div>
        </div>
      </div>
    </section><!-- page ends-->